<div class="container mt-4">
    <h5 style="font-weight: 700" class=" mt-3">
        PikMybox Terms of Use
    </h5>
    <p>
        This is a legal and binding agreement between you, the user ("User" or "You") of the Services,
        as defined below, and Lynkit Solutions Private Limited (LSPL) stating the terms that govern
        Your use of the Site (www.pikmybox.com), as defined below. BY ACCEPTING THESE TERMS OF
        USE IN ANY MANNER OR ACCESSING THIS WEBSITE, YOU CONSENT, AGREE AND UNDERTAKE
        TO ABIDE, BE BOUND BY AND ADHERE TO THE TERMS OF USE and the Privacy Policy
        accessible at www.pikmybox.com/termsofuse and www.pikmybox.com/privacypolicy respectively
        and any other terms which govern the Site (together referred to as "Terms of Use" or "Terms" or
        "Terms and Conditions") AND IF YOU DO NOT AGREE TO THESE TERMS OF USE, YOU ARE NOT
        ENTITLED TO AVAIL OF / USE THE SERVICES AND ANY USE THEREAFTER SHALL BE
        UNAUTHORIZED.

    </p>
    <h5 style="font-weight: 700" class=" mt-3">
        Description of Services
    </h5>
    <p>
        LSPL provides an online web application - www.pikmybox.com, which provides an online
        service to users for completing and printing of regulatory documentation, through its web and
        mobile applications.
    </p>
    <h5 style="font-weight: 700" class=" mt-3">
        Subscription Services
    </h5>
    <p>
        Some of the features made available on the application can be availed only by registered users
        under a subscription model (“Subscription User”). You may need to register yourself on the site
        to avail these services on a subscription model (“Subscription”). To become a Subscription User,
        You may be required to provide certain personal information to LSPL and may be required to
        make payments ("Subscription Fee") as per the applicable subscription plan through a debit
        card, credit card, internet banking or through, a prepaid e-wallet or other payment method
        accepted by Lynkit Solutions Pvt Ltd ("Payment Method(s)") that You opt for during registration.
        LSPL will be using third party payment gateways to process and facilitate the payment of Your
        Subscription Fee to LSPL. Different kinds of subscriptions plans may be offered, subject to
        different services, limitations and restrictions and the cost of each of these subscription plans
        may vary. Please refer to pricing plans for the up to date information on available subscription
        plans.
    </p>
    <h5 style="font-weight: 700" class=" mt-3">
        Subscriptions and Payments Terms and Conditions
    </h5>
    <ol>
        <li class="mt-2">
            LSPL will automatically start billing as per the Subscription plan selected by You
            at the start of your subscription date, if there are adequate funds available in
            your account. Adequate funds in your account are when you have funds equal to
            or greater than the charges required for the subscription plan.
        </li>
        <li class="mt-2">
            Funds can be added to Your account through any Payment Method selected by
            you through the third-party payment gateway. It may take a few days for Your
            payment to be reflected in your "My Account" section.
        </li>
        <li class="mt-2">
            Funds equivalent to the subscription fee of your selected subscription plan will
            be deducted from your account at the beginning of your subscription and on
            each subsequent renewal automatically (as per the Subscription plan chosen by
            You) unless and until You cancel Your Subscription or the Subscription is
            otherwise suspended or discontinued pursuant to these Terms. To see the
            commencement date for Your next renewal period or to cancel Your
            subscription, You need to visit the "My Account" section.
        </li>
        <li class="mt-2">
            LSPL will automatically bill You as per the selected Subscription period on a
            monthly or annual basis. A monthly subscription plan will automatically renew on
            the same date of the following month, or the 1st of the following month in cases
            when the same date of the following month is not applicable. An annual
            subscription plan will automatically renew on the same date and month of the
            following year.
        </li>
        <li class="mt-2">
            In case of inadequate funds in your account, your subscription would not be
            automatically renewed and the services that you subscribed would be
            discontinued, starting from the date of renewal, until adequate funds are
            available in your account.
        </li>
        <li class="mt-2">
            If You change Your subscription plan, this could result in changing the day on
            which You are billed and/or the amount which You are billed. Further, on
            changing your existing Subscription plan to another, You would be billed as per
            the new Subscription plan from the next billing/ renewal cycle. Alternatively, in
            the case of an upgrade, You could select to pay the difference in rates for the
            new Subscription plan selected, and begin using the new subscription plan with
            immediate effect in the current billing cycle. In case the rate for the new
            Subscription plan is less than that of the existing Subscription plan, you will be
            billed accordingly from the next billing/ renewal cycle.
        </li>
        <li class="mt-2">
            LSPL reserves the right to change, terminate or otherwise amend the
            Subscription plans, Subscription Fees and billing cycles at its sole discretion and
            at any time. Such amendments shall be effective upon posting on the Site and
            Your continued use of the Service shall be deemed to be Your conclusive
            acceptance of such amendments. In case of any change in the Subscription Fee
            payable, LSPL will notify you in advance and will not charge without your explicit
            consent.
        </li>
        <li class="mt-2">
            The Subscription Fees specified for each Subscription plan do not include
            applicable taxes.
        </li>
        <li class="mt-2">
            The Subscription Fees billed are non-refundable irrespective of whether the
            Subscription have been availed by You or not.
        </li>
        <li class="mt-2">
            Any changes in the Subscription Plan opted by You is effective only after the
            expiry of the current Subscription period for which You have already been billed.
            Accordingly, the Subscription as per revised plan opted by You shall be effective
            only after the expiry of the then current Subscription period. Any request for
            change or cancellation in any Subscription plan prior to the expiration of the
            current Subscription plan period will not entail You with a refund for any portion
            of the Subscription Fee paid by You for the unexpired period, and you may
            continue to avail the subscribed services till end of the subscription period and
            auto-renewals would be discontinued.
        </li>
        <li class="mt-2">
            You also understand and acknowledge that LSPL only facilitates the third party
            payment gateway for processing of payments. This facility is managed by the
            third party payment gateway provider and You are required to follow all the
            terms and conditions of such third party payment gateway provider.
        </li>
        <li class="mt-2">You are responsible for the accuracy and authenticity of the information
            provided by You, including the bank account number/credit card details and any
            other information requested during the payment process. You agree and
            acknowledge that LSPL shall not be liable and in no way be held responsible for
            any losses whatsoever, whether direct, indirect, incidental or consequential,
            including without limitation any losses due to delay in processing of payment
            instruction or any online payment payment / credit / debit card fraud.
        </li>
        <li class="mt-2">
            You can access the status of Your Subscription or cancel your subscription
            anytime through the "My Account" section. Post cancellation of Your
            Subscription, if you wish to re-subscribe to the Subscription, you may do so from
            Your "My Account" page.
        </li>
        <li class="mt-2">
            You can file any complaint related to payment processing on the Site and the
            same will be forwarded to the concerned third party payment gateway provider
            for redressal.
        </li>
        <li class="mt-2">
            Upon addition of funds to your account through any of the Payment Modes
            made available by the payment gateway provider, you will receive a confirmation
            receipt from the payment gateway provider, and the same will be reflected in
            “My Account”. Upon deduction of funds from your account for a selected
            subscription, an invoice will be made available to You in the "My Account"
            section which can be downloaded by You in pdf format.
        </li>
        <li class="mt-2">
            It is hereby clarified that the Subscription offered to You are offered by LSPL
            and not by any third party including any payment gateway service providers.
        </li>
    </ol>
</div>